import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";
import Loading from "../loading/Loading";

const Footer = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const handleRedirect = (packageFilter) => {
    setIsLoading(true);
    setTimeout(() => {
      navigate(`/tours?package=${packageFilter}`);
      window.scrollTo(0, 0);
      setIsLoading(false);
    }, 1000);
  };

  return (
    <>
      {isLoading && <Loading />}
      <footer className="footer-container">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">Twin Travel Coron</h3>
              <p>Explore TrioPalawan with us. Your adventure starts here.</p>
              <img
                src="/logo.png"
                alt="Logo"
                className="footer-logo"
                loading="lazy"
              />
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/tours">Tours</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Contact Us</h3>
              <ul>
                <li>
                  📞 Phone: <a href="tel:+639066603788">+63 906 660 3788</a>
                </li>
                <li>
                  ✉️ Email:{" "}
                  <a href="mailto:twintravelcoron.reservation@gmail.com">
                    twintravelcoron.reservation@gmail.com
                  </a>
                </li>
                <li>
                  📍 Address:
                  <a
                    href="https://www.google.com/maps?q=Poblacion+3,+Barangay+3,+Coron,+5316+Palawan"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Poblacion 3, Barangay 3, Coron, 5316 Palawan
                  </a>
                </li>
                <li>
                  💬 WhatsApp:{" "}
                  <a
                    href="https://wa.me/639066603788"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +63 906 660 3788
                  </a>
                </li>
                <li>
                  💜 Viber:{" "}
                  <a href="viber://chat?number=+639066603788">
                    +63 906 660 3788
                  </a>
                </li>
                <li>
                  Facebook:{" "}
                  <a href="https://www.facebook.com/TwinTravelcoron2019">
                    Twin Travel Coron
                  </a>
                </li>
                <li>
                  Instagram:{" "}
                  <a href="https://www.instagram.com/twin_travel_coron/">
                    Twin Travel Coron
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Packages</h3>
              <p className="footer-link" onClick={() => handleRedirect("3D2N")}>
                3D2N
              </p>
              <p className="footer-link" onClick={() => handleRedirect("4D3N")}>
                4D3N
              </p>
              <p className="footer-link" onClick={() => handleRedirect("5D4N")}>
                5D4N
              </p>
              <p className="footer-link" onClick={() => handleRedirect("6D5N")}>
                6D5N
              </p>
              <p className="footer-link" onClick={() => handleRedirect("7D6N")}>
                7D6N
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              &copy; <span>{year}</span> Twin Travel Coron. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
      <p className="developer">
        Designed and Developed by :{" "}
        <a href="https://sassawebtechsolutions.pro/">SWTS</a>
      </p>
    </>
  );
};

export default Footer;
